import cookieIcon from "../../images/cookie.svg";
import classes from "./CookiesModal.module.css";
import xIcon from "../../images/xIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setCookie,
  setCookies,
  setIsCookieModalShown,
} from "../../redux/globalFunctions";
import { useState } from "react";
import { ToggleBtn } from "../buttons/toggleBtn/ToggleBtn";
import translations from "../../en.json";
import translationsNo from "../../no.json";

export function CookiesModal() {
  const dispatch = useDispatch();
  const { cookies, language } = useSelector((state) => state.global);
  const [isClicked, setIsClicked] = useState(false);

  const handleCookieChange = (key) => {
    setIsClicked(true);
    dispatch(setCookie({ name: key, value: !cookies[key] }));
  };

  function handleAcceptCookies() {
    dispatch(setCookies(true));
    dispatch(setIsCookieModalShown(false));
  }

  function handleCloseModal() {
    dispatch(setIsCookieModalShown(false));
  }

  function handleDeclineAll() {
    dispatch(setCookies(false));
    dispatch(setIsCookieModalShown(false));
  }

  const cookieModalData =
    language === "en" ? translations.cookiesModal : translationsNo.cookiesModal;

  const buttonText = isClicked
    ? cookieModalData.buttons.saveAndAccept
    : cookieModalData.buttons.accept;

  return (
    <div className="overlay" id="popupOverlay">
      <div className={classes.container}>
        <header className={classes.header}>
          <div className={classes.headerContent}>
            <img src={cookieIcon} alt={cookieModalData.header.iconAlt} />
            <h1>{cookieModalData.header.title}</h1>
          </div>
          <img
            src={xIcon}
            alt={cookieModalData.header.closeButtonAlt}
            onClick={handleCloseModal}
          />
        </header>
        <div className={classes.content}>
          <p>
            {cookieModalData.content.intro}{" "}
            <a href={cookieModalData.content.cookiePolicyLink}>
              {cookieModalData.content.cookiePolicyLink}
            </a>
          </p>
          <h3>{cookieModalData.content.cookiePreferencesTitle}</h3>
          <p>{cookieModalData.content.cookiePreferencesDescription}</p>
          <div className={classes.disableAllDiv}>
            <span>{cookieModalData.disableAll.text}</span>
            {Object.values(cookies).every((value) => value === true) ? (
              <button
                onClick={() => {
                  dispatch(setCookies(false));
                  setIsClicked(true);
                }}
              >
                {cookieModalData.disableAll.disableButton}
              </button>
            ) : (
              <button
                onClick={() => {
                  dispatch(setCookies(true));
                  setIsClicked(true);
                }}
              >
                {cookieModalData.disableAll.enableButton}
              </button>
            )}
          </div>
          {cookieModalData.cookieSections.map((section, index) => (
            <div key={index} className={classes.containerDiv}>
              <div>
                <h5>{section.title}</h5>
                <ToggleBtn
                  isDisabled={cookies[section.redux]}
                  setIsDisabled={() => handleCookieChange(section.redux)}
                />
              </div>
              <p>{section.description}</p>
            </div>
          ))}
        </div>
        <div className={classes.buttons}>
          <button
            className={classes.acceptBtn}
            onClick={
              buttonText === "ACCEPT ALL"
                ? handleAcceptCookies
                : handleCloseModal
            }
          >
            {buttonText}
          </button>
          <button className={classes.declineBtn} onClick={handleDeclineAll}>
            {cookieModalData.buttons.decline}
          </button>
        </div>
      </div>
    </div>
  );
}
